import client from './api-client';

export const getGrillaImplicado = async(query) => {
    try {
        
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                grillaImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosPantalla = async(query) => {
    try {
        
        const response = await client.getImplicado(`caso/implicado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosPantalla: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboSeguro = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboSeguro: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getParametrosFecha = async(query) => {
    try {
        
        const response = await client.getImplicado(`parametros?q=${query}`);
        console.log(response, "Parametros")
        if (response.status === 200 && response.data.code === 1) {
            return {
                parametros: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboCompanias = async(query) => {
    try {
        
        const response = await client.getImplicado(`companias?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCompanias: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getComboTipoVehiculo = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);     
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboVehiculos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboMarcas = async(query) => {
    try {
        
        const response = await client.getImplicado(`marcas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboMarcas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboPais = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboPais: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboComunas = async(query) => {
    try {
        
        const response = await client.getImplicado(`generales?q=${query}`);   
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboComunas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const actualizarImplicado= async(newImplicado) => {
    try {
        const response = await client.postImplicado('caso/implicado',newImplicado)      

        if (response.status === 200 && response.data.code === 1) {
            return {respuestaImplicado: response.data};
        } else {
            return {respuestaImplicado: response.data};
        }
        
    } catch(error){
        throw error;
        console.log(error)
    }
}